import fetch from 'isomorphic-fetch';

const cache = {};
const callQueue = {};
const listeners = {};

export default function getPersonalizedConfig(key, userId, sig) {
    return new Promise((resolve, reject) => {
        if (cache[key]) {
            return resolve(cache[key]);
        }

        if (callQueue[key]) {
            if (!listeners[key]) {
                listeners[key] = [];
            }

            listeners[key].push(() => resolve(cache[key]));

            return null;
        }

        callQueue[key] = true;

        return fetch(`https://fp.vg.no/front-personalization/get/${key}:${userId}`, {
            method: 'POST',
            body: JSON.stringify({
                validationData: sig,
            }),
        })
            .then((persResult) => persResult.json())
            .then((adConfig = {}) => {
                let { value = {} } = adConfig;
                value = value || {};

                cache[key] = value;
                callQueue[key] = false;

                if (Object.keys(listeners).indexOf(key) >= 0) {
                    listeners[key].map((callback) => callback(value));
                    delete listeners[key];
                }

                resolve(value);
            })
            .catch((err) => {
                callQueue[key] = false;
                reject(err);
            });
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/get-personalized-config.js
 **/